<template>
    <div>
        <BackButton/>

        <h2>Kontaktformular</h2>
        <p>Nehmen Sie Kontakt mit der Studiengangleitung auf. Ihre Ergebnisse werden automatisch mitgesendet.</p>

        <b-alert v-model="showMailSuccessfulAlert" variant="success">
            <font-awesome-icon :icon="['fas', 'check']"/>
            Es wurde ein E-Mail mit Ihren Ergebnissen an die Studiengangleitung versendet.
        </b-alert>
        <b-alert v-model="showMailUnsuccessfulAlert" variant="danger">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']"/>
            Es konnte kein E-Mail mit Ihren Ergebnissen versendet werden.
        </b-alert>

        <b-form @submit="onSubmit">
            <b-form-group
                    id="input-group-1"
                    label="E-Mail Adresse *"
                    label-for="input-1"
            >
                <b-form-input
                        id="input-1"
                        required
                        type="email"
                        v-model="form.email"
                />
            </b-form-group>
            <b-form-group
                    id="input-group-2"
                    label="Vorname *"
                    label-for="input-2"
            >
                <b-form-input
                        id="input-2"
                        required
                        type="text"
                        v-model="form.firstName"
                />
            </b-form-group>
            <b-form-group
                    id="input-group-3"
                    label="Nachname *"
                    label-for="input-3"
            >
                <b-form-input
                        id="input-3"
                        required
                        type="text"
                        v-model="form.lastName"
                />
            </b-form-group>
            <b-form-group
                    id="input-group-4"
                    label="Kommentar"
                    label-for="input-4"
            >
                <b-form-textarea
                        id="input-4"
                        v-model="form.comment"
                />
            </b-form-group>
            <b-form-group
                    id="input-group-5"
                    label="Wie empfanden Sie die Beratung?"
                    label-for="input-5"
            >
                <div id="input-5">
                    <div class="row">
                        <div class="col">
                            <FeedbackPanel v-on:click="setSmileSelected" :icon="'smile'" :is-selected="isSmileSelected"></FeedbackPanel>
                        </div>
                        <div class="col">
                            <FeedbackPanel v-on:click="setMehSelected" :icon="'meh'" :is-selected="isMehSelected"></FeedbackPanel>
                        </div>
                        <div class="col">
                            <FeedbackPanel v-on:click="setFrownSelected" :icon="'frown'" :is-selected="isFrownSelected"></FeedbackPanel>
                        </div>
                    </div>
                </div>
            </b-form-group>

            <b-form-group id="input-group-6" label="Würden Sie das Beratungstool weiterempfehlen?" label-for="input-6">
                <b-form-radio-group
                        id="input-6"
                        v-model="form.selectedToolRecommendation"
                        :options="form.recommendationOptions"
                        name="recommendation-options"
                        stacked>
                </b-form-radio-group>
            </b-form-group>

            <CancelButton router-link="/ergebnisse"/>
            <b-button type="submit" variant="primary">
                <font-awesome-icon :icon="['fas', 'envelope']"/>
                Senden
            </b-button>
        </b-form>
    </div>
</template>

<script>
    import BackButton from "./helper-components/BackButton";
    import CancelButton from "./helper-components/CancelButton";
    import {herokuApi} from "../api/axiosConfig";
    import FeedbackPanel from "./helper-components/FeedbackPanel";

    export default {
        name: "ContactForm",
        components: {FeedbackPanel, CancelButton, BackButton},
        data() {
            return {
                form: {
                    email: null,
                    firstName: null,
                    lastName: null,
                    comment: null,
                    selectedFeedback: null,
                    recommendationOptions: [
                        { text: "Ja", value: "yes" },
                        { text: "Nein", value: "no" },
                        { text: "Weiss nicht", value: "unsure" }
                    ],
                    selectedToolRecommendation: null,
                },
                showMailSuccessfulAlert: false,
                showMailUnsuccessfulAlert: false,
                feedbackSelected: true,
                isSmileSelected: false,
                isMehSelected: false,
                isFrownSelected: false,
                axiosErrors: [],
                axiosHasError: false,
                axiosLoading: false
            }
        },
        methods: {
            onSubmit(evt) {
                evt.preventDefault();
                this.sendMail();
            },
            setSmileSelected() {
                this.isMehSelected = false;
                this.isFrownSelected = false;
                if (!this.isSmileSelected) {
                    this.isSmileSelected = true;
                    this.form.selectedFeedback = "good";
                } else {
                    this.isSmileSelected = false;
                    this.form.selectedFeedback = null;
                }
                return this.isSmileSelected;
            },
            setMehSelected() {
                this.isSmileSelected = false;
                this.isFrownSelected = false;
                if (!this.isMehSelected) {
                    this.isMehSelected = true;
                    this.form.selectedFeedback = "average";
                } else {
                    this.isMehSelected = false;
                    this.form.selectedFeedback = null;
                }
                return this.isMehSelected;
            },
            setFrownSelected() {
                this.isSmileSelected = false;
                this.isMehSelected = false;
                if (!this.isFrownSelected) {
                    this.isFrownSelected = true;
                    this.form.selectedFeedback = "bad";
                } else {
                    this.isFrownSelected = false;
                    this.form.selectedFeedback = null;
                }
                return this.isFrownSelected;
            },
            /* Sends a request with the data from the Contact Form to the Back-End.
            The Back-End then sends an E-Mail with the recommender results, which are saved for this session. */
            sendMail() {
                herokuApi
                    .post('/recommender/submit', {
                        email: this.form.email,
                        firstName: this.form.firstName,
                        lastName: this.form.lastName,
                        comment: this.form.comment,
                        feedback: this.form.selectedFeedback,
                        toolRecommendation: this.form.selectedToolRecommendation
                    })
                    .then(() => this.axiosLoading = true)
                    .catch(error => {
                        this.axiosErrors.push(error);
                        this.axiosHasError = true;
                        this.showMailUnsuccessfulAlert = this.axiosHasError;
                    })
                    .finally(() => {
                        this.axiosLoading = false;
                        this.showMailSuccessfulAlert = !this.axiosHasError;
                    })
            }
        }
    }
</script>

<style scoped>

</style>